import Plugin from './autocomplete.js';
import Plugin$1 from './breadcrumb.js';
import Plugin$2 from './button.js';
import Plugin$3 from './carousel.js';
import Plugin$4 from './checkbox.js';
import Plugin$6 from './collapse.js';
import Plugin$5 from './clockpicker.js';
import { P as Plugin$7 } from './index-eQI_WrqY.js';
export { C as Color } from './index-eQI_WrqY.js';
import Plugin$8 from './datepicker.js';
import Plugin$9 from './datetimepicker.js';
import Plugin$a from './dialog.js';
export { DialogProgrammatic } from './dialog.js';
import Plugin$b from './dropdown.js';
import Plugin$c from './field.js';
import Plugin$d from './icon.js';
import Plugin$e from './image.js';
import Plugin$f from './input.js';
import Plugin$g from './loading.js';
export { LoadingProgrammatic } from './loading.js';
import Plugin$h from './menu.js';
import Plugin$i from './message.js';
import Plugin$j from './modal.js';
export { ModalProgrammatic } from './modal.js';
import Plugin$l from './notification.js';
export { NotificationProgrammatic } from './notification.js';
import Plugin$k from './navbar.js';
import Plugin$m from './numberinput.js';
import Plugin$n from './pagination.js';
import Plugin$o from './progress.js';
import Plugin$p from './radio.js';
import Plugin$q from './rate.js';
import Plugin$r from './select.js';
import Plugin$t from './skeleton.js';
import Plugin$s from './sidebar.js';
import Plugin$u from './slider.js';
import Plugin$v from './snackbar.js';
export { SnackbarProgrammatic } from './snackbar.js';
import Plugin$w from './steps.js';
import Plugin$x from './switch.js';
import Plugin$y from './table.js';
import Plugin$z from './tabs.js';
import Plugin$A from './tag.js';
import Plugin$B from './taginput.js';
import Plugin$C from './timepicker.js';
import Plugin$D from './toast.js';
export { ToastProgrammatic } from './toast.js';
import Plugin$E from './tooltip.js';
import Plugin$F from './upload.js';
import { m as merge } from './helpers-O9h6_ICO.js';
export { b as bound, A as copyAppContext, d as createAbsoluteElement, l as createNewEvent, f as escapeRegExpChars, z as getComponentFromVNode, n as getMonthNames, g as getValueByPath, o as getWeekdayNames, h as hasFlag, i as indexOf, u as isCustomElement, v as isDefined, x as isFragment, c as isMobile, w as isNil, y as isTag, e as isVueComponent, q as isWebpSupported, p as matchWithGroups, a as mod, k as multiColumnSort, j as removeDiacriticsFromString, r as removeElement, s as sign, t as toCssWidth, B as translateTouchAsDragEvent } from './helpers-O9h6_ICO.js';
import { s as setOptions, c as config } from './config-nHWiBviw.js';
import { r as registerComponentProgrammatic } from './plugins-C7548x21.js';
import ConfigComponent from './config.js';
import './Autocomplete-PtCdVo_0.js';
import './CompatFallthroughMixin-Ev2XGfi3.js';
import './FormElementMixin-ILDlgM3i.js';
import './Input-0ivJhXUC.js';
import './Icon-fJqkx1gN.js';
import 'vue';
import './Button-KVoJ7jHH.js';
import './InjectedChildMixin-95-VbgK7.js';
import './Image-s3Blktdg.js';
import './Checkbox-o2PhGepR.js';
import './CheckRadioMixin-I9QgrPGQ.js';
import './TimepickerMixin-M_pQh7UT.js';
import './DropdownItem-yQcaSZL4.js';
import './trapFocus-IMs77O3T.js';
import './Field-CMd66v8h.js';
import './typeof-Z4rCTFCZ.js';
import './classCallCheck-E4khD9xn.js';
import './Select-DY-wGhZc.js';
import './Tooltip-WHq2LJas.js';
import './Datepicker-r7KMGxsC.js';
import './Timepicker-sqpkdcr1.js';
import './Modal-au57IFsU.js';
import './Loading-p2sa5IKE.js';
import './ssr-jg9-YOst.js';
import './MessageMixin-KdZp92I_.js';
import './Progress-7Ux1HulH.js';
import './NoticeMixin-6c_QVv-2.js';
import './Pagination-FX3EMQVP.js';
import './TabbedChildMixin-foL4cK-M.js';
import './SlotComponent-bRURhcxz.js';
import './Tag-0i8ndmgD.js';

var components = /*#__PURE__*/Object.freeze({
    __proto__: null,
    Autocomplete: Plugin,
    Breadcrumb: Plugin$1,
    Button: Plugin$2,
    Carousel: Plugin$3,
    Checkbox: Plugin$4,
    Clockpicker: Plugin$5,
    Collapse: Plugin$6,
    Colorpicker: Plugin$7,
    Datepicker: Plugin$8,
    Datetimepicker: Plugin$9,
    Dialog: Plugin$a,
    Dropdown: Plugin$b,
    Field: Plugin$c,
    Icon: Plugin$d,
    Image: Plugin$e,
    Input: Plugin$f,
    Loading: Plugin$g,
    Menu: Plugin$h,
    Message: Plugin$i,
    Modal: Plugin$j,
    Navbar: Plugin$k,
    Notification: Plugin$l,
    Numberinput: Plugin$m,
    Pagination: Plugin$n,
    Progress: Plugin$o,
    Radio: Plugin$p,
    Rate: Plugin$q,
    Select: Plugin$r,
    Sidebar: Plugin$s,
    Skeleton: Plugin$t,
    Slider: Plugin$u,
    Snackbar: Plugin$v,
    Steps: Plugin$w,
    Switch: Plugin$x,
    Table: Plugin$y,
    Tabs: Plugin$z,
    Tag: Plugin$A,
    Taginput: Plugin$B,
    Timepicker: Plugin$C,
    Toast: Plugin$D,
    Tooltip: Plugin$E,
    Upload: Plugin$F
});

var Buefy = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // Options
    setOptions(merge(config, options, true));
    // Components
    for (var componentKey in components) {
      Vue.use(components[componentKey]);
    }
    // Config component
    registerComponentProgrammatic(Vue, 'config', ConfigComponent);
    Vue.config.globalProperties.$buefy.globalNoticeInterval = null;
  }
};

export { Plugin as Autocomplete, Plugin$1 as Breadcrumb, Plugin$2 as Button, Plugin$3 as Carousel, Plugin$4 as Checkbox, Plugin$5 as Clockpicker, Plugin$6 as Collapse, Plugin$7 as Colorpicker, ConfigComponent as ConfigProgrammatic, Plugin$8 as Datepicker, Plugin$9 as Datetimepicker, Plugin$a as Dialog, Plugin$b as Dropdown, Plugin$c as Field, Plugin$d as Icon, Plugin$e as Image, Plugin$f as Input, Plugin$g as Loading, Plugin$h as Menu, Plugin$i as Message, Plugin$j as Modal, Plugin$k as Navbar, Plugin$l as Notification, Plugin$m as Numberinput, Plugin$n as Pagination, Plugin$o as Progress, Plugin$p as Radio, Plugin$q as Rate, Plugin$r as Select, Plugin$s as Sidebar, Plugin$t as Skeleton, Plugin$u as Slider, Plugin$v as Snackbar, Plugin$w as Steps, Plugin$x as Switch, Plugin$y as Table, Plugin$z as Tabs, Plugin$A as Tag, Plugin$B as Taginput, Plugin$C as Timepicker, Plugin$D as Toast, Plugin$E as Tooltip, Plugin$F as Upload, Buefy as default, merge };
